export * from '@firebase/storage';
//# sourceMappingURL=index.esm.js.map
